<template lang="html">
<div>
    <v-container style="text-align: center;">
      <div>
        <h1>{{$t('techno.TITLE')}}</h1>
        <div class="subh1"> {{$t('techno.TEXT')}} </div>
      </div>

      </v-container>

    <v-container>
      <v-layout row wrap >
        <v-flex  md3  v-for="card in cards" >
          <v-container>
          <v-card elevation="6" color="grey lighten-2">
              <v-img
                :src="card.image"
                aspect-ratio="1.5"
              ></v-img>

              <v-card-title primary-title style="padding-left: 10px; padding-right: 10px; text-align: center;">
                <div>
                  <h3 class="headline mb-0">{{card.title}}</h3>
                </div>
              </v-card-title>

              <v-card-text style="padding-left: 10px; padding-right: 10px; text-align: center;">
              <h3 align-center v-html="card.text"></h3>
            </v-card-text>

            </v-card>
          </v-container>
          </v-flex>
      </v-layout>
    </v-container>
</div>
</template>

<script>
export default {
  data() {
    return {
      cards: [{
        image: require('../../public/img/ecran carte.png'),
        title: this.$t('card.techno1.TITLE'),
        text: this.$t('card.techno1.TEXT')
      }, {
        image: require('../../public/img/Reconnaissance plantes.png'),
        title: this.$t('card.techno2.TITLE'),
        text: this.$t('card.techno2.TEXT')
      }, {
        image: require('../../public/img/Data analyse.png'),
        title: this.$t('card.techno3.TITLE'),
        text: this.$t('card.techno3.TEXT')
      }, {
        image: require('../../public/img/water balance.png'),
        title: this.$t('card.techno4.TITLE'),
        text: this.$t('card.techno4.TEXT')
      }]
    }
  }
}
</script>

<style lang="css" scoped>
</style>
